import { listKevelZoneName } from '@/domain/useCases/adminBarInfo/adminBarUtils'
import { Center } from '@/types/models'
import { isNumber } from '@/utils/checks'
import { isSamhsa, isLuxCenter } from '@/domain/center'

interface GenerateZoneName {
  (props: { zone: string | number; center: Center }): string
}

/**
 * Generates a zone name based on the provided zone and center.
 *
 * If the center is identified as SAMHSA, it returns 'SAMHSA'.
 * Otherwise, it checks if the zone is a number and returns the corresponding zone name
 * using the listKevelZoneName function. If the zone is not a number, it returns the zone as is.
 *
 */
const generateZoneName: GenerateZoneName = ({ zone, center }) => {
  if (isSamhsa(center) && !isLuxCenter(center)) {
    return 'SAMHSA'
  }

  return isNumber(zone) ? listKevelZoneName(zone) : zone
}

export default generateZoneName
